import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot) {
        if (localStorage.getItem('ls.userInfo')) {
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: ('/' + route.url) }});
        return false;
    }
}


// WEBPACK FOOTER //
// /Users/Anders/workspace/DOFBasenCli/src/app/share/security/auth-guard.ts